export default __webpack_public_path__ + "static/media/kooiring.91fdb32c.png";